var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "happy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.708,
    height: 16.708,
    viewBox: "0 0 16.708 16.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3233",
    "data-name": "Group 3233",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3232",
    "data-name": "Group 3232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    d: "M14.261,2.447A8.354,8.354,0,1,0,2.447,14.261,8.354,8.354,0,1,0,14.261,2.447ZM8.354,15.713a7.359,7.359,0,1,1,7.359-7.359A7.368,7.368,0,0,1,8.354,15.713Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-delete",
    "data-name": "Icon feather-delete",
    transform: "translate(-12.975 -8.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25712",
    "data-name": "Path 25712",
    d: "M24.183,13.5,18,19.683",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25713",
    "data-name": "Path 25713",
    d: "M18,13.5l6.183,6.183",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.4e9eb185bf72b682a358551a41103344.svg";
export { ForwardRef as ReactComponent };